import React from "react";
import type { IFormItemLayout, TSourceOfFund } from "@adgm/cross-models";
import MultiCheckboxSubForm from "./MultiCheckboxSubForm";
import { INDIVIDUAL_SOURCE_OF_FUND_CONFIG } from "./IndividualSourceOfFundFormConfig";

interface IProps extends IFormItemLayout<TSourceOfFund | null> {
  value?: TSourceOfFund | null;
  onChange: (value: TSourceOfFund) => void;
  style?: any;
}

/**
 * 个人资金来源表单组件
 * 用于输入个人资金来源信息
 */
export const IndividualSourceOfFundForm: React.FC<IProps> = props => {
  return (
    <MultiCheckboxSubForm<TSourceOfFund> {...props} config={INDIVIDUAL_SOURCE_OF_FUND_CONFIG} />
  );
};
